export type PredefinedDateRangePreset = 'week' | 'month' | 'year';

export const getPredefinedDateRange = (preset: PredefinedDateRangePreset, now = new Date()): { start: string; end: string } => {
    const start = new Date(now);
    const end = new Date(now);

    if (preset === 'week') {
        end.setDate(end.getDate() + 7);
    } else if (preset === 'month') {
        end.setMonth(end.getMonth() + 1);
    } else {
        end.setFullYear(end.getFullYear() + 1);
    }

    return { start: start.toISOString(), end: end.toISOString() };
};
